module.exports = __webpack_public_path__ + "img/tick_white.8e718ecf.svg";